/** @jsxImportSource @emotion/react */
import React, { Fragment, useImperativeHandle, useState } from 'react';

import { useOnboardingDataContext } from '../../context/OnboardingData';
import getCategoryDataLayer from '../../utils/getCategoryDataLayer';
import getNextQuestionId from '../../utils/getNextQuestionId';
import LocationAutoSuggest from '../LocationAutoSuggest';
import useStyles from './styles';

const PostcodeQuestion = React.forwardRef(
  (
    { placeholder, onAnswer, ageRanges, selectedAge, isVisible, questionOrder },
    postcodeRef
  ) => {
    const styles = useStyles();
    const [locationData, setLocationData] = useState({});
    const [errorMessage, setErrorMessage] = useState();
    const {
      OnboardingContext,
      setOnboardingDataContext,
      arrowContext,
      setArrowFunction,
    } = useOnboardingDataContext();

    const selectpostcodeAnswer = () => {
      setTimeout(() => {
        onAnswer({
          answerData: {
            Latitude: locationData.latitude,
            Longitude: locationData.longitude,
            ReadableLocation: locationData.readableLocation,
          },
          nextQuestionId: getNextQuestionId({
            ageRanges,
            selectedAge,
          }),
        });
      }, 500);
    };

    useImperativeHandle(postcodeRef, () => ({
      selectpostcodeAnswer,
    }));

    const onError = message => setErrorMessage(message);

    return (
      <Fragment>
        <LocationAutoSuggest
          placeholder={placeholder}
          onError={onError}
          setLocationData={value => {
            setLocationData(value);
            setArrowFunction(
              value?.readableLocation && value?.latitude ? true : false
            );
            setOnboardingDataContext({
              ...OnboardingContext,
              location:
                value.readableLocation +
                `${
                  value.secondaryLocation ? ', ' + value.secondaryLocation : ''
                }`,
            });
          }}
          css={styles.locationInput}
          isVisible={isVisible}
        />
        <button
          id={`question_${questionOrder}_next`}
          aria-label="Next"
          css={styles.buttonNext(arrowContext)}
          disabled={arrowContext === false ? true : false}
          onClick={() => {
            setArrowFunction(false);
            selectpostcodeAnswer();
            getCategoryDataLayer({
              eventAction: `Step ${OnboardingContext.step} - Next CTA`,
              eventLabel: OnboardingContext.question,
              eventparameter1: `${OnboardingContext.age}${
                OnboardingContext.agegroup
                  ? ' , ' + OnboardingContext.agegroup
                  : ''
              }`,
              eventparameter2: OnboardingContext.disability,
              eventparameter3: locationData.readableLocation,
              gender_group: OnboardingContext.gender_group,
              location: OnboardingContext.location,
              event_name: 'next_button_click',
            });
            setOnboardingDataContext({
              ...OnboardingContext,
              location: locationData.readableLocation,
            });
          }}
        >
          Next
        </button>
        {errorMessage && <div css={styles.error}>{errorMessage}</div>}
      </Fragment>
    );
  }
);

export default PostcodeQuestion;
